"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateList = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Free = _interopRequireDefault(require("../Free"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var updateList = function updateList(list, i, val) {
  var copy = _toConsumableArray(list);

  copy[i] = val;
  return copy;
};

exports.updateList = updateList;

var ListState = function ListState(_ref) {
  var children = _ref.children,
      unused = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(_Free.default, unused, function (_ref2) {
    var state = _ref2.state,
        set = _ref2.set;
    return React.Children.only(children({
      state: state,
      append: function append(val) {
        return set(_toConsumableArray(state).concat([val]));
      },
      prepend: function prepend(val) {
        return set([val].concat(_toConsumableArray(state)));
      },
      slice: function slice() {
        return set(state.slice.apply(state, arguments));
      },
      update: function update() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return set(updateList.apply(void 0, [state].concat(args)));
      }
    }));
  });
};

ListState.propTypes = {
  children: _propTypes.default.func.isRequired,
  initial: _propTypes.default.array
};
ListState.defaultProps = {
  initial: []
};
var _default = ListState;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/state/List/index.js
// module id = ./node_modules/quark-core/components/state/List/index.js
// module chunks = 0